import { styled } from "goober";
import { PressButton } from "../PressButton";

export const DownloadButton = styled(PressButton)`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  height: 24px;
  border-radius: 6px;
  background: var(--alpha4);
  color: var(--text-primary);

  &:hover:not(:disabled) {
    background: var(--alpha8);
  }

  &:disabled {
    opacity: 0.5;
  }
`;
